import { Leaf, Instagram, MessageCircle, Mail } from "lucide-react";
import { whatsappUrl, instagramUrl } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#071e10] text-slate-300 py-14 border-t border-white/5">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 grid place-items-center">
                <Leaf className="w-5 h-5 text-white" />
              </div>
              <div className="text-white font-bold text-lg">
                iGreen <span className="text-emerald-400">Energy</span>
              </div>
            </div>
            <p className="mt-4 text-slate-400 text-sm max-w-md leading-relaxed">
              Transforme conexões em renda recorrente. Torne-se um Licenciado iGreen Energy e ajude milhares de pessoas a economizar na conta de luz.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href={instagramUrl} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/10 grid place-items-center hover:text-emerald-400 hover:border-emerald-400/40 transition-colors"><Instagram className="w-4 h-4" /></a>
              <a href={whatsappUrl} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/10 grid place-items-center hover:text-emerald-400 hover:border-emerald-400/40 transition-colors"><MessageCircle className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <div className="text-white font-bold mb-4">Navegação</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#oportunidade" className="hover:text-emerald-400 transition-colors">A Oportunidade</a></li>
              <li><a href="#produtos" className="hover:text-emerald-400 transition-colors">Produtos</a></li>
              <li><a href="#ganhos" className="hover:text-emerald-400 transition-colors">Seus Ganhos</a></li>
              <li><a href="#executivo" className="hover:text-emerald-400 transition-colors">Seu Gestor</a></li>
              <li><a href="#contato" className="hover:text-emerald-400 transition-colors">Contato</a></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-bold mb-4">Contato</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="https://wa.me/5547999641269" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-emerald-400 transition-colors">
                  <MessageCircle className="w-4 h-4 text-emerald-400" /> WhatsApp: (47) 99964-1269
                </a>
              </li>
              <li>
                <a href="mailto:rodneybe@icloud.com" className="inline-flex items-center gap-2 hover:text-emerald-400 transition-colors">
                  <Mail className="w-4 h-4 text-emerald-400" /> rodneybe@icloud.com
                </a>
              </li>
              <li>Rodney Espindola</li>
              <li>Gestor iGreen Energy</li>
            </ul>
            <a href="mailto:rodneybe@icloud.com" className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-emerald-500 text-white text-sm font-semibold hover:bg-emerald-600 transition-colors">
              <Mail className="w-4 h-4" /> Enviar Email
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} iGreen Energy — Rodney Espindola. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
}
